import { css } from 'styled-components';

export const CommonStyles = css`
  .asterisk-sign {
    margin-left: 2px;
    color: red;
  }
`;
